import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AssignTaskComponent } from 'app/layout/common/assign-task/assign-task.component';
import { InwardsService } from 'app/modules/admin/transactions/inwards/inwards.service';
import { Inward } from 'app/modules/admin/transactions/inwards/inwards.types';

@Injectable({ providedIn: 'root' })
export class PendingTaskInwardService implements OnDestroy {


    private destroy$ = new Subject<void>();
    private popupOpen = false;

    constructor(
        private _matDialog: MatDialog,
        private _inwardService: InwardsService
    ) { }

    /**
     * Open the pending-task popup on demand.
     *
     * Triggered by the header button (beside the notification icon).
     * This runs the SAME logic that used to fire automatically every hour
     * and on every SignalR status update — fetch the latest pending inwards,
     * then open AssignTaskComponent — but now ONLY when the user clicks.
     */
    openPopup(): void {
        if (this.popupOpen) {
            return;
        }

        this._inwardService.getPendingInwards()
            .pipe(takeUntil(this.destroy$))
            .subscribe(inwards => this.showDialog(inwards || []));
    }

    private showDialog(inwards: Inward[]): void {
        if (this.popupOpen) {
            return;
        }
        this.popupOpen = true;

        this._matDialog.open(AssignTaskComponent, {
            panelClass: 'assign-task-panel',
            width: '900px',
            maxWidth: '95vw',
            maxHeight: '85vh',
            autoFocus: false,
            data: inwards
        }).afterClosed().subscribe(() => {
            this.popupOpen = false;
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
